angular
	.module 'App.Component'
	.component 'dropdown',
	{
		templateUrl: '@component/input/dropdown/dropdown.view.html'
		controller: 'DropdownComponent'
		controllerAs: 'dropdown'
		require:
			ngModelController: 'ngModel'
		bindings:
			id: '<?'
			disabled: '<?'
			# Need prefix "is", otherwise component becomes required, not input field itself
			isRequired: '<?'
			ngModel: '='
			label: '<?'
			placeholder: '<?'
			repositoryName: '<?repository'
			items: '<?'
			allowEmpty: '<?'
			emptyValue: '<?'
			emptyText: '<?'
			keyProperty: '<?'
			textProperty: '<?'
			orderByProperty: '<?'
			isOpen: '<?'
			headless: '<?'
			openDirection: '<?open'
			openPosition: '<?position'
			onBeforeSearch: '&?'
			onChange: '&?'
			searchFn: '&?'
			isSearchOfSelectedItemEnabled: '<?'
	}

class DropdownComponent extends AbstractController
	@register()
	@inject '$injector',
		'$filter'
		'$timeout'
		'$scope'
		'$q'
		'$element'
		'translate'
		'parseBool'

	initialize: ->
		@id ?= 'dropdown-' + @controllerId
		@disabled ?= false
		@isSearchOfSelectedItemEnabled ?= true
		@disabled = @parseBool(@disabled)
		@isRequired ?= false
		@required = @parseBool(@isRequired)
		@items ?= []
		@keyProperty ?= 'id'
		@textProperty ?= 'name'
		@orderByProperty ?= @textProperty
		@allowEmpty ?= !@required
		@emptyValue ?= null
		@emptyText ?= 'general.all'
		@placeholder ?= @label
		@headless ?= false
		@openDirection ?= 'down'
		@openPosition ?= 'left'
		@isOpen ?= false

		if @headless
			@$element
				.addClass('headless')
				.addClass("open-#{@openPosition}")

		@$element.addClass("open-#{@openDirection}")

		@term = ''
		@isLocalSearch = !@repositoryName?
		@selectedItems = @items
		@pageSize = 250
		@hasItems = true

		@initializeRepository()
		@search()

		if @disabled
			isDisabledWatcherUnregister = @$scope.$watch 'dropdown.disabled', (newState) =>
				if newState == true
					return

				@search().then => isDisabledWatcherUnregister()

		itemsWatcherUnregister = @$scope.$watch 'dropdown.items', (newItems) =>
			# We are managing items ourself when doing online search, host should not temper with results
			if !@isLocalSearch
				itemsWatcherUnregister()

				return

			@items = newItems
			@search()

	initializeRepository: ->
		if !@repositoryName?
			return

		if !@$injector.has(@repositoryName)
			throw new Error("Repository #{@repositoryName} does not exist for #{@constructor.name}")

		@repository = @$injector.get(@repositoryName)

	open: ->
		if @disabled || @headless
			return

		if @isOpen == false
			@$timeout => angular.element("#dropdown-search-#{@id}")?.focus()

		@isOpen = true

	close: ->
		if @headless
			return

		@isOpen = false

	search: ->
		if @repository? && !@isLocalSearch
			promise = @searchOnline()
		else
			promise = @searchLocal()

		return promise.then =>
			@selectedItems = @$filter('orderBy')(_.values(@selectedItems), @orderByProperty)
			@selectedItems = _.indexBy(@selectedItems, @keyProperty)

			@hasItems = !_.isEmpty(@selectedItems)

	searchOnline: ->
		if @disabled && @isSearchOfSelectedItemEnabled
			return @searchSelectedItem()

		query = @repository.createQuery()
		query.setPagination(0, @pageSize)

		if @term != ''
			query.criteria @textProperty, 'LIKE', @term

		if @onBeforeSearch?
			@onBeforeSearch({query: query, term: @term})

		if @searchFn?
			promise = @searchFn({query: query, term: @term})
		else
			promise = @repository.getEntities(query)

		return promise
			.then (items) =>
				@items = items

				# No longer perform online search if it's initial search and have loaded all items
				@isLocalSearch = @term == '' && @items.length < @pageSize

				return @searchSelectedItem().finally =>
					@selectedItems = @items
			.catch (response) =>
				@handleErrors(response)

	searchLocal: ->
		if @term == '' || @items.length == 0
			@selectedItems = @items

			return @$q.when(true)

		@selectedItems = []

		for item in @items
			if item[@textProperty].toLowerCase().includes(@term.toLowerCase())
				@selectedItems.push(item)

		return @$q.when(true)

	searchSelectedItem: ->
		if _.isEmpty(@ngModel) || @term != ''
			return @$q.when(true)

		for item in @items
			if item[@keyProperty] == @ngModel
				return @$q.when(true)

		return @repository
			.getEntity(@ngModel)
			.then (item) =>
				@items.push(item)
			.catch =>
				@items.unshift({
					"#{@keyProperty}": @ngModel
					"#{@textProperty}": "#{@translate('general.deleted')} (#{id})"
					disabled: true
				})

	selectItem: (item) ->
		if item? && item.disabled == true
			return

		if item == null
			item =
				"#{@keyProperty}": @emptyValue
				"#{@textProperty}": '-- ' + @translate(@emptyText) + ' --'

		@close()

		@ngModel = item[@keyProperty]
		# Manually trigger dirty state, as just assignment does not change this state and form stays pristine
		@ngModelController.$setDirty()

		if @onChange?
			# Using timeout to allow Angular to "catch up" with ngModel change, otherwise callback will be called
			# before ngModel value change apply
			@$timeout => @onChange({item: item})
